<template>
  <div class="task-detail__wrap">
    <div class="task-detail-panel" :class="{ 'panel-show': showPanel }">
      <div class="blur-bg map-blur-panel"></div>
      <div class="task-detail__content">
        <div class="title">任务详情</div>
        <el-scrollbar class="scroll-content" style="height: calc(100% - 60px)">
          <el-row :span="24" class="row">
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">任务名称 ：</label>
                <span class="item-value">{{ tableDetail.taskName }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">任务状态 ：</label>
                <span class="item-value">
                  {{ taskStatusList[tableDetail.taskStatus - 1] }}</span
                >
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">窗口数量 ：</label>
                <span class="item-value">{{ tableDetail.windowNum }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">巡逻间隔 ：</label>
                <span class="item-value">{{ tableDetail.playDuration }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">循环巡逻 ：</label>
                <span class="item-value">{{
                  tableDetail.weatherToPoll == 1 ? "是" : "否"
                }}</span>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">是否超时 ：</label>
                <span class="item-value">{{
                  tableDetail.taskStatus == 4 ? "是" : "否"
                }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">开始时间 ：</label>
                <span class="item-value">
                  {{
                    $utils.getDateStr(
                      tableDetail.planStartTime,
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  }}
                </span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">结束时间 ：</label>
                <span class="item-value">
                  {{
                    $utils.getDateStr(
                      tableDetail.planEndTime,
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  }}
                </span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="item-content">
                <label class="item-label">执行要求 ：</label>
                <span class="item-value">{{ tableDetail.remark }}</span>
              </div>
            </el-col>
          </el-row>
        </el-scrollbar>

        <div class="footer">
          <el-button type="info" @click="handleClosePanel"> 关闭</el-button>
          <el-button
            @click="handleExactor"
            type="primary"
            v-if="tableDetail.taskStatus != 3"
            >立即执行</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "task-detail__wrap",
  props: {
    tableDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showPanel: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      taskStatusList: [
        "待执行",
        "执行中",
        "已完成",
        "已超时",
        // { label: " 待执行", value: 1 },
        // { label: " 执行中", value: 2 },
        // { label: " 已完成", value: 3 },
        // { label: " 已超时", value: 4 },
      ],
    };
  },
  methods: {
    handleExactor() {
      this.$emit("handleExactor");
    },
    handleClosePanel() {
      this.$emit("handleCloseDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.task-detail {
  &__wrap {
    position: absolute;
    top: 0px;
    display: flex;
    right: 0px;
    height: 100%;
    z-index: 2;

    .panel-show {
      padding: 12px;
      width: 380px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0px !important;
      @include set_animation(all);
    }
    .task-detail-panel {
      padding: 12px;
      width: 380px;
      height: 100%;
      position: absolute;
      top: 0;
      right: -450px;
      @include set_animation(all);
    }
  }

  &__content {
    height: calc(100% - 24px);
    width: calc(100% - 24px);
    position: absolute;
    .title {
      border-left: 4px solid #407aee;
      position: relative;
      line-height: 16px;
      text-align: left;
      padding-left: 10px;
      font-size: 16px;
      margin: 0px 10px 12px;
    }
    .row {
      @include set_theme_color(background-color, map-panel-content);
    }
    .item-content {
      margin: 12px;
      display: flex;
      line-height: 24px;
    }
    .item-label {
      width: 80px;
    }
    .item-value {
      line-height: 24px;
    }
    .footer {
      width: 100%;
      text-align: center;
      position: absolute;
    }
  }
}
</style>